<template>
    <div id="app">
		<div v-if="serverReady === true">
			<div id="nav">
				<nav-bar/>
			</div>
			<transition name="component-fade" mode="out-in">
				<router-view/>
			</transition>
			<footer-component class="footer"/>
		</div>
		<div v-else>
			<div style="margin: 1em; margin-top: 300px">
				<strong class="text-primary" style="font-size: 2em">{{loadingPct}}%</strong>
				<b-progress :value="loadingPct" :max="100" height="2rem" animated></b-progress>
			</div>
		</div>
	</div>
</template>

<script>

import NavBar from '@/components/NavBar';
import FooterComponent from '@/components/Footer';

export default {
	name: 'app',
	components: {
		NavBar, FooterComponent
	},
	data () {
		return {
			loadingPct: 0, serverReady: false
		}
	},
	mounted() {
		this.checkHealth();
	},
	methods: {
		checkHealth() {
			this.animateProgBar();
			this.$store.dispatch('FETCH_HEALTH').then(() => {
				this.loadingPct = 100;
				setTimeout(() => {
					this.serverReady = true;
				}, 1000);
			}).catch(err => {
				throw err;
			});
		},
		animateProgBar() {
			this.animateTimer(this.animateProgBar);
		},
		animateTimer(cb) {
			setTimeout(() => {
				if (this.loadingPct === 70) {
					this.loadingPct = 0;
					return this.checkHealth();
				} else if(this.loadingPct < 100) this.loadingPct = this.loadingPct + 5;
				cb();
			}, 1000);
		}
	}
}
</script>

<style>
	/* Sticky footer styles
	-------------------------------------------------- */
	html {
		position: relative;
		min-height: 100%;
	}
	body {
		/* Margin bottom by footer height */
		margin-bottom: 270px;
	}
	.footer {
		position: absolute;
		bottom: 0;
		width: 100%;
		/* Set the fixed height of the footer here */
		height: 270px;
		background-color: #f5f5f5;
	}

	@media only screen and (max-width: 500px) {
		body {
		/* Margin bottom by footer height */
			margin-bottom: 450px;
		}
		.footer {
			position: absolute;
			bottom: 0;
			width: 100%;
			/* Set the fixed height of the footer here */
			height: 450px;
			background-color: #f5f5f5;
		}
	}

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin: 0;
		padding: 0; 
	}

	.btn:focus, .form-control:focus {
		-webkit-box-shadow: none !important;
		-moz-box-shadow: none !important;
		box-shadow: none !important;
	}

	.form-control:focus {
		border-color: #495057
	}

	.component-fade-enter-active, .component-fade-leave-active {
		transition: all .3s ease;
	}
	.component-fade-enter, .component-fade-leave-to
		/* .component-fade-leave-active below version 2.1.8 */ {
		transform: translateX(10px);
		opacity: 0;
	}

	a {
		color: inherit;
	}
	a:hover {
		color: inherit;
		text-decoration: none;
	}
</style>
